<script setup lang="ts">
defineProps<{
  open: boolean
}>()
const emit = defineEmits<{
  (e: 'onClose'): void
}>()
</script>

<template>
  <glx-modal :open="open">
    <section class="container">
      <div class="title">
        非授权服务商，无申请项目扶持计划资格!
      </div>
      <div class="btnFloor">
        <button class="btnConfirm" @click="emit('onClose')">
          确定
        </button>
      </div>
    </section>
  </glx-modal>
</template>

<style scoped lang="scss">
section.container {
  width: 864px;
  height: 212px;
  background: #FFFFFF;
  border-radius: 6px;

  position: absolute;
  top: 450px;
  left: 50%;
  transform: translateX(-50%);
  padding-top: 60px;

  > .title {
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #191919;
    line-height: 1;

    text-align: center;
  }

  > .btnFloor {
    margin-top: 44px;

    display: flex;
    justify-content: center;

    > .btnConfirm {
      width: 140px;
      height: 51px;
      background: #FF0000;
      border-radius: 6px;

      font-family: PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 51px;
    }
  }
}
</style>